import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import router from "@/router";
const cashSimulationModule = namespace("cashSimulation");
let ChangeParamsButton = class ChangeParamsButton extends Vue {
    goToCreditParams() {
        this.clearSimulation();
        if (this.$route.name !== "CreditParams") {
            router.push({ name: "CreditParams" });
        }
    }
};
tslib_1.__decorate([
    Prop({ default: "Zmień parametry kredytu" })
], ChangeParamsButton.prototype, "label", void 0);
tslib_1.__decorate([
    cashSimulationModule.Action("clearSimulation")
], ChangeParamsButton.prototype, "clearSimulation", void 0);
ChangeParamsButton = tslib_1.__decorate([
    Component
], ChangeParamsButton);
export default ChangeParamsButton;
